export const messages = {
    nb: {    

        TS1M_Overskrift: `Økten din er i ferd med å utløpe.`,
        TS1M_message: `På grunn av inaktivitet er du i ferd med å bli logget ut. Trykk “Fortsett” for å bli på siden`,                        
        TS1M_Avbryt: `Fortsett`,                        
        TS1M_Lukk: `Lukk`,                            
    }
    
} 